
import { mapState, mapActions } from "vuex";
import SubscriptionInactiveDialog from "../dialogs/subscription-inactive-dialog.vue";
import SubscriptionPlanDialog from "../dialogs/subscription-plan-dialog.vue";

export default {
  components: {
    SubscriptionPlanDialog,
    SubscriptionInactiveDialog
  },
  props: {
    styleProps: {
      type: String,
      default: "background-color: #FF3030"
    }
  },
  data() {
    return {
      dialog: true,
      showSubscriptionBanner: false,
      showSubscriptionPlanDialog: false,
      showSubscriptionInactiveDialog: false,
      isSubscriptionPlanDialogClosable: true,
      bannerText: "",
      recursivePaymentDialogIntervalId: null,
      TRIAL_PERIOD: 30,
      TRIAL_PERIOD_ALERT_DAYS: 3,
      GRACE_PERIOD: 15,
      RECURSIVE_PAYMENT_ALERT_DELAY: 3600000
      // RECURSIVE_PAYMENT_ALERT_DELAY: 5000,
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "subscription"]),
    isTrialUser() {
      return (
        this.subscription.state == "trial_running" ||
        this.subscription.state == "trial_expired"
      );
    }
  },
  watch: {
    locationDetails() {
      this.checkSubscriptionEnabled();
    }
  },
  mounted() {
    this.checkSubscriptionEnabled();

    this.$nuxt.$on("payment-success", () => {
      this.checkSubscriptionEnabled();
    });
    // this.showSubscriptionInactiveDialog = true;
  },
  methods: {
    ...mapActions("restaurant", ["getSubscription"]),
    ...mapActions("payment", ["getInvoices"]),
    checkSubscriptionEnabled() {
      if (this.locationDetails && this.locationDetails.ready_for_subscription) {
        this.getSubscription().finally((data) => {
          this.checkSubscriptionStatus();
        });
      } else {
        this.showSubscriptionBanner = false;
        this.showSubscriptionPlanDialog = false;
      }
    },
    checkSubscriptionStatus() {
      if (!this.subscription) return;
      this.showSubscriptionBanner = false;
      this.showSubscriptionPlanDialog = false;
      this.isSubscriptionPlanDialogClosable = false;
      if (this.subscription.state == "subscription_active") {
        //SUBSCRIBED user
        if (this.subscription.subscription?.status === "subscription_active") {
          //SUBSCRIBED PAID user
          return;
        } else if (
          this.subscription.subscription?.status === "new_invoice_generated"
        ) {
          //SUBSCRIBED user with invoice generated
          this.getInvoices();
          return;
        } else if (
          this.subscription.subscription?.status === "new_invoice_due"
        ) {
          this.getInvoices();
          const daysLeft =
            this.getTimeDifferenceInDays(
              this.subscription?.subscription?.last_invoice_due_date
            ) * -1;
          this.bannerText = `There is a pending invoice that's due in the next ${daysLeft} ${
            daysLeft > 1 ? "days" : "day"
          }, please make the payment to continue uninterrupted service.`;
          this.showSubscriptionBanner = true;
          return;
          //SUBSCRIBED user with invoice due
          // TODO ::: get invoice
        } else if (
          this.subscription.subscription?.status === "new_invoice_overdue"
        ) {
          this.showSubscriptionInactiveDialog = true;
          //SUBSCRIBED user invoice with overdue
        }
      } else if (this.subscription.state == "subscription_inactive") {
        this.getInvoices();
        //SUBSCRIBED user inactive
        this.showSubscriptionInactiveDialog = true;
      } else if (this.subscription.state == "trial_running") {
        //TRIAL user
        if (this.subscription.trial?.status === "trial_running") {
          //TRIAL period user
          return;
        } else if (
          this.subscription.trial?.status === "trial_about_to_expire"
        ) {
          //TRIAL period user about to expire
          const daysLeft =
            this.getTimeDifferenceInDays(
              this.subscription?.trial?.trial_end_date
            ) * -1;
          if (daysLeft) {
            this.bannerText = `Please note that your trial will be expired within next
               ${daysLeft} ${daysLeft > 1 ? "days" : "day"}`;
          } else {
            this.bannerText = `Please note that your trial will be expired today`;
          }
          this.showSubscriptionBanner = true;
        }
      } else if (this.subscription.state == "trial_expired") {
        //TRIAL period user expired
        if (
          this.subscription.trial?.status === "trial_expired_in_grace_period"
        ) {
          //TRIAL period expired user in grace period
          const expiredDays =
            this.getTimeDifferenceInDays(
              this.subscription?.trial?.trial_end_date
            ) * -1;
          if (expiredDays == 0) {
            this.bannerText = `Your subscription has expired today.`;
          } else {
            this.bannerText = `Your subscription has expired   ${expiredDays} ${
              expiredDays > 1 ? "days" : "day"
            }  ago.`;
          }
          this.showSubscriptionBanner = true;
          this.initRecursivePaymentDialog();
        } else if (this.subscription.trial?.status === "trial_expired") {
          //TRIAL period user inactive
          this.bannerText = `Your trial period has expired.`;
          this.isSubscriptionPlanDialogClosable = false;
          this.showSubscriptionPlanDialog = true;
          this.showSubscriptionBanner = true;
        }
      }

      // if (this.subscription.state == "active") {
      //   //SUBSCRIBED PAID user
      // } else if (this.subscription.state == "expired") {
      //   const expiredDays = this.getTimeDifferenceInDays(
      //     this.subscription.subscription_end_date
      //   );
      //   this.showSubscriptionBanner = true;
      //   if (expiredDays <= this.subscription.subscription_grace_days) {
      //     //SUBSCRIBED user about to expire
      //     this.bannerText = `There is a pending invoice that's due in the next 4 days, please make the payment to continue uninterrupted service.`;
      //     this.showSubscriptionBanner = true;
      //     this.initRecursivePaymentDialog();
      //   } else {
      //     //SUBSCRIBED user expired
      //     this.bannerText = `You have a pending invoice of ₹798. please complete the payment to continue using our services`;
      //     this.isSubscriptionPlanDialogClosable = false;
      //     this.showSubscriptionBanner = true;
      //     this.showSubscriptionPlanDialog = true;
      //   }
      // } else {
      //   //TRIAL user
      //   this.isTrialUser = true;
      //   const daysLeft =
      //     this.getTimeDifferenceInDays(this.subscription.trial_end_date) * -1;
      //   if (this.subscription.state == "trial") {
      //     //TRIAL period user
      //     if (daysLeft <= this.subscription.trial_end_warning_days) {
      //       //TRIAL period user about to expire
      //       this.bannerText = `Please note that your trial will be expired within next
      //        ${daysLeft} ${daysLeft > 1 ? "days" : "day"}`;
      //       this.showSubscriptionBanner = true;
      //     }
      //   } else if (this.subscription.state == "trial_expired") {
      //     //TRIAL period expired user
      //     this.showSubscriptionBanner = true;
      //     if (daysLeft * -1 <= this.subscription.subscription_grace_days) {
      //       //TRIAL period user about to expire
      //       this.bannerText = `Your subscription has expired ${Math.abs(
      //         expiredDays
      //       )} days ago.`;
      //       this.showSubscriptionBanner = true;
      //       this.initRecursivePaymentDialog();
      //     } else {
      //       //TRIAL period user expired
      //       this.bannerText = `Your trial period has expired.`;
      //       this.isSubscriptionPlanDialogClosable = false;
      //       this.showSubscriptionPlanDialog = true;
      //       this.showSubscriptionBanner = true;
      //     }
      //   }
      // }

      // else {
      //   const trialPeriodUsage = this.getTimeDifferenceInDays(
      //     new Date(this.locationDetails.trial_start_date)
      //   );
      //   if (
      //     trialPeriodUsage <
      //     this.TRIAL_PERIOD - this.TRIAL_PERIOD_ALERT_DAYS
      //   ) {
      //   } else if (trialPeriodUsage < this.TRIAL_PERIOD) {
      //     //TRIAL period user about to expire
      //     this.showSubscriptionBanner = true;
      //     const daysLeft = this.TRIAL_PERIOD - trialPeriodUsage;
      //   } else if (!this.locationDetails.subscription_due_date) {
      //     //TRIAL period user expired
      //     this.bannerText = `Your ${this.TRIAL_PERIOD} Days Free Trial Expired.`;
      //     this.showSubscriptionBanner = true;
      //     this.showSubscriptionPlanDialog = true;
      //     this.isSubscriptionPlanDialogClosable = false;
      //   } else {
      //     //SUBSCRIBED user
      //     const expiredDays = this.getTimeDifferenceInDays(
      //       new Date(this.locationDetails.subscription_due_date)
      //     );
      //     if (expiredDays > 0) {
      //       //SUBSCRIBED user expired
      //       this.showSubscriptionBanner = true;
      //       this.bannerText = `Your subscription has expired ${Math.abs(
      //         expiredDays
      //       )} days ago.`;
      //       if (expiredDays > this.GRACE_PERIOD) {
      //         //SUBSCRIBED user expired and GRACE PERIOD over
      //         this.showSubscriptionPlanDialog = true;
      //         this.isSubscriptionPlanDialogClosable = false;
      //       }
      //     }
      //   }
      // }
    },
    initRecursivePaymentDialog() {
      this.isSubscriptionPlanDialogClosable = true;
      this.showSubscriptionPlanDialog = true;
      this.recursivePaymentDialogIntervalId = setInterval(
        (() => {
          this.isSubscriptionPlanDialogClosable = true;
          this.showSubscriptionPlanDialog = true;
        }).bind(this),
        this.RECURSIVE_PAYMENT_ALERT_DELAY
      );
    },
    hanldeMakePayment() {
      if (this.isTrialUser) {
        this.isSubscriptionPlanDialogClosable = true;
        this.showSubscriptionPlanDialog = true;
      } else {
        this.$vuetify.breakpoint.mdAndUp
          ? this.$router.push(`/invoices/`)
          : this.$router.push(`/settings/billing`);
      }
      // if (this.subscription && this.subscription.id) {
      //   this.proceedRazorpayPayment();
      // } else {
      //   this.showSubscriptionPlanDialog = true;
      // }
    },
    initPayment() {
      this.$nuxt.$emit("make-payment", this.subscription.latest_invoice?.id);
    }
  },
  beforeDestroy() {
    clearInterval(this.recursivePaymentDialogIntervalId);
    this.$nuxt.$off("payment-success");
  }
};
